import Skeleton from 'antd/lib/skeleton'; // specific import reduced bundle with 1.8mb...
import styled from 'styled-components';

import theme from '../../../assets/theme';
import { useBreakPoint } from '../../../hooks/useBreakPoint';
import useMixpanelFlag from '../../../hooks/useMixpanelFlag';
import { MOBILE_TO_DESKTOP_BREAKPOINT_PX } from '../../../utils/creator';

const DesignerSkeletonLoader = () => {
  const isDesktop = useBreakPoint(MOBILE_TO_DESKTOP_BREAKPOINT_PX);
  const isAgentEnabled = useMixpanelFlag('agent');
  if (isDesktop && !isAgentEnabled) {
    return (
      <MainContainer>
        <FloatingTabsSkeleton>
          <Skeleton.Input active={true} />
          <Skeleton.Input active={true} />
          <Skeleton.Input active={true} />
          <Skeleton.Input active={true} />
        </FloatingTabsSkeleton>
        <FloatingTabPaneSkeleton>
          <Skeleton active={true} />
        </FloatingTabPaneSkeleton>
        <SlideAndSlideListSkeleton />
      </MainContainer>
    );
  } else if (isDesktop && isAgentEnabled) {
    return (
      <AgentMainContainer>
        <FloatingTabPaneSkeleton>
          <Skeleton active={true} />
        </FloatingTabPaneSkeleton>
        <SlideAndSlideListSkeleton />
      </AgentMainContainer>
    );
  } else {
    return (
      <MainContainer>
        <SlideAndSlideListSkeleton />
        <FloatingTabsSkeleton>
          <Skeleton.Input active={true} />
          <Skeleton.Input active={true} />
          <Skeleton.Input active={true} />
          <Skeleton.Input active={true} />
        </FloatingTabsSkeleton>
      </MainContainer>
    );
  }
};

const SlideAndSlideListSkeleton = () => {
  return (
    <SlideAndSlideListContainer>
      <NoSlideContainer />
      <FloatingSlideOverviewContainer>
        <Skeleton.Input active={true} />
        <Skeleton.Input active={true} />
        <Skeleton.Input active={true} />
      </FloatingSlideOverviewContainer>
    </SlideAndSlideListContainer>
  );
};

export const FloatingSlideOverviewContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  border-radius: ${theme.effects.floatingCreatorElementBorderRadius};
  box-shadow: ${theme.effects.floatingCreatorElementShadow};
  overflow: hidden;

  gap: 12px;
  padding-left: 12px;
  padding-top: 20px;

  .ant-skeleton-input {
    width: 113px;
    height: 80px;
    border-radius: 5px;
    margin: 0px 6px;
    min-width: unset;
  }
`;

const NoSlideContainer = styled.div`
  flex: 1;
  height: 100%;
  overflow-y: auto;
  position: relative;
`;

export const SlideAndSlideListContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: auto 140px;

  @media (max-width: 900px) {
    padding: 6px;
    height: calc(100% - 76px);
  }
`;

export const FloatingTabPaneSkeleton = styled.div`
  width: 100%;
  padding: 20px;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-radius: ${theme.effects.floatingCreatorElementBorderRadius};
  box-shadow: ${theme.effects.floatingCreatorElementShadow};
  overflow-y: scroll;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  .ant-skeleton-input {
    width: 100%;
    height: 50px;
    border-radius: 5px;
    min-width: unset;
  }
  .ant-skeleton-element {
    width: 100%;
    height: 120px;
    border-radius: 5px;
    min-width: unset;
  }
`;

const FloatingTabsSkeleton = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: white;
  box-shadow: ${theme.effects.floatingCreatorElementShadow};
  border-radius: ${theme.effects.floatingCreatorElementBorderRadius};
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  // Skeleton specific styles
  gap: 12px;
  padding-top: 6px;

  .ant-skeleton-input {
    width: calc(100% - 12px);
    height: 50px;
    border-radius: 5px;
    margin: 0px 6px;
    min-width: unset;
  }

  @media (max-width: 900px) {
    height: 70px;
    flex-direction: row;
    overflow-x: scroll;
    overflow-y: hidden;
    scrollbar-width: none;
    width: calc(100% - 12px);
    margin: 0px 6px 6px 6px;
    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }

    padding-top: 0px;
    padding-left: 6px;
    .ant-skeleton-input {
      height: calc(100% - 12px);
      width: 60px;
      border-radius: 5px;
      margin: 6px 0px;
      min-width: unset;
    }
  }
`;

const MainContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 80px 350px auto;
  gap: 6px;
  padding: 10px 5px;
  height: calc(100% - 60px);
  position: relative;
  overflow: hidden;
  background: ${theme.colors.creatorBackgroundGrey};

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    padding: 0px 0px 0px 0px;
    gap: 0px;
  }
`;
const AgentMainContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 430px auto;
  gap: 6px;
  padding: 10px 5px;
  height: calc(100% - 60px);
  position: relative;
  overflow: hidden;
  background: ${theme.colors.creatorBackgroundGrey};

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    padding: 0px 0px 0px 0px;
    gap: 0px;
  }
`;

export default DesignerSkeletonLoader;
